import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './EditButton.css';

const queryString = require('query-string');

const EditButton = (props: any) => {
    const handleClick = () => {
        var parsed = queryString.parse(window.location.search);

        if (parsed && parsed.m === undefined) {
            var currentQueryParams = queryString.stringify(parsed);
            let url = window.location.origin + window.location.pathname + "?m=e&" + currentQueryParams;
            window.location.href = url;
        }
        else if (parsed && parsed.m === "r") {
            parsed.m = "e";
            var currentQueryParams = queryString.stringify(parsed);
            let url = window.location.origin + window.location.pathname + "?" + currentQueryParams;
            window.location.href = url;
        }
        else if (parsed && parsed.m === "e") {
            parsed.m = "r";
            var currentQueryParams = queryString.stringify(parsed);
            let url = window.location.origin + window.location.pathname + "?" + currentQueryParams;
            window.location.href = url;
        }
        
    };

    return (
        <React.Fragment>
            <div className="btn-group btn-edit-footer" role="group" aria-label="...">
                <button type="button" className="btn btn-default-edit" title="Edit" onClick={handleClick} >
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                </button>
            </div>
        </React.Fragment>
    );
}

export default connect()(EditButton);
